import { QueryClient } from "@tanstack/react-query";
import { LoaderFunctionArgs } from "react-router";
import { JOBS_QUERIES } from "~/shared/api/jobs/jobs.queries";
import { getTableParamsFromRequest } from "~/shared/util/tableHelpers";
import { NOT_IN_PROCESS_TABLE_PARAMS_KEY } from "~/team/views/JobInterviewsView/components/ListNotCurrentProcess";
import { IN_PROCESS_TABLE_PARAMS_KEY } from "~/team/views/JobInterviewsView/components/ListProcessTable";

export async function jobInterviewsViewLoader(queryClient: QueryClient, { request, params }: LoaderFunctionArgs) {
  try {
    const { jobId } = params ?? {};

    if (!jobId) {
      throw new Error("Job ID is required to load interviews");
    }

    queryClient.ensureQueryData(
      JOBS_QUERIES.processList(
        jobId,
        getTableParamsFromRequest({
          request,
          key: IN_PROCESS_TABLE_PARAMS_KEY,
          filters: {
            current: true,
          },
        }),
      ),
    );

    queryClient.ensureQueryData(
      JOBS_QUERIES.processList(
        jobId,
        getTableParamsFromRequest({
          request,
          key: NOT_IN_PROCESS_TABLE_PARAMS_KEY,
          filters: {
            current: false,
          },
        }),
      ),
    );

    return null;
  } catch (error) {
    return null;
  }
}
